<div class="icon_header_char">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" (click)="onCancel()"> </app-button-icon>
</div>
<div class='container'>
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
    <div class='buttons'>
        <app-button-primary [text]="cancelText" (click)="onCancel()"></app-button-primary>
        <app-button-primary [text]="confirmText" (click)="onConfirm()"></app-button-primary>
    </div>
</div>